var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKahunLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244.16 75",
    role: "img",
    "aria-describedby": "Kahun",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("title", null, "Kahun"), /*#__PURE__*/React.createElement("style", null, "\n            .cls-22{fill:#fff;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 75,
    height: 75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M103.3,21h5.36a.85.85,0,0,1,.85.85V40.25l8.8-10.65a.86.86,0,0,1,.66-.3h6.29a.85.85,0,0,1,.63,1.41l-8.53,9.53a.85.85,0,0,0,0,1.1l10.43,12.91a.85.85,0,0,1-.66,1.38h-6.29a.84.84,0,0,1-.66-.32l-7-8.92a.86.86,0,0,0-1.32,0l-2.13,2.55a.82.82,0,0,0-.2.54v5.32a.85.85,0,0,1-.85.85H103.3a.85.85,0,0,1-.85-.85v-33A.85.85,0,0,1,103.3,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.13,42.46c0-7.58,4.64-13.69,11.91-13.69a10.27,10.27,0,0,1,8.21,3.74V30.15a.85.85,0,0,1,.85-.85h5.2a.85.85,0,0,1,.85.85V54.78a.85.85,0,0,1-.85.85h-5.2a.85.85,0,0,1-.85-.85V52.47c-1.84,2.53-5.16,3.69-8.21,3.69C132.77,56.16,128.13,50.05,128.13,42.46Zm20,0c0-4.1-2.63-7.16-6.26-7.16-3.8,0-6.54,3.06-6.54,7.16s2.74,7.17,6.54,7.17C145.46,49.63,148.09,46.68,148.09,42.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.37,21h5.36a.85.85,0,0,1,.85.85v10.8a9.67,9.67,0,0,1,8.11-3.85c6.85,0,9.38,4.32,9.38,11.69V54.78a.85.85,0,0,1-.85.85h-5.36a.85.85,0,0,1-.85-.85V41.36c0-3.85-1.16-5.9-4.63-5.9-3.74,0-5.8,3-5.8,6.79V54.78a.85.85,0,0,1-.85.85h-5.36a.85.85,0,0,1-.85-.85v-33A.85.85,0,0,1,161.37,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M189.76,45.05V30.15a.85.85,0,0,1,.84-.85H196a.85.85,0,0,1,.85.85v14c0,3.68,1.58,5.37,4.85,5.37,3.69,0,5.48-3.11,5.48-6.69V30.15a.85.85,0,0,1,.85-.85h5.36a.85.85,0,0,1,.84.85V54.78a.85.85,0,0,1-.84.85h-4.94a.85.85,0,0,1-.85-.85V52c-1.58,2.58-5.16,4.21-8.22,4.21C192.07,56.16,189.76,51.89,189.76,45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M220.42,29.3h5.2a.85.85,0,0,1,.85.85v2.68a9.81,9.81,0,0,1,8.32-4.06c7,0,9.37,4.48,9.37,11.69V54.78a.85.85,0,0,1-.85.85H238a.85.85,0,0,1-.84-.85V41.36c0-3.85-1-5.9-4.59-5.9s-5.9,2.84-5.9,6.85V54.78a.85.85,0,0,1-.84.85h-5.36a.85.85,0,0,1-.85-.85V30.15A.85.85,0,0,1,220.42,29.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "37.08 45.17 18.64 26.72 23.36 22 37.08 35.73 50.81 22 55.53 26.72 37.08 45.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 19.43,
    y: 45.11,
    width: 35.31,
    height: 6.68
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKahunLogo);
export default __webpack_public_path__ + "static/media/kahunLogo.6243ea4e0cf689ae3f8e2de17a538967.svg";
export { ForwardRef as ReactComponent };